import { GET_CUSTOMER_ISSUES, GET_CUSTOMER_ISSUES_SUCCESS, GET_CUSTOMER_ISSUES_ERROR, GET_CUSTOMER_ISSUES_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetCustomerIssues = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_ISSUES:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_CUSTOMER_ISSUES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_CUSTOMER_ISSUES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_CUSTOMER_ISSUES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetCustomerIssues;
